const BASE_COMPRESSIBLE_MIME_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/webp',
  'image/gif',
  'image/bmp',
  'image/png'
];

export function buildCompressibleMimeTypes(convertHeic: boolean): Set<string> {
  const types = new Set(BASE_COMPRESSIBLE_MIME_TYPES);

  if (convertHeic) {
    types.add('image/heic');
    types.add('image/heif');
  }

  return types;
}
